export type LiveChatStatus = 'WAITING' | 'TRANSFERING' | 'CONNECTED';

export const isLiveChatWaiting = (status: LiveChatStatus): boolean => status === 'WAITING' || status === 'TRANSFERING';
